// A page left open across deploys can ask for a code chunk that no longer
// exists, and without help the page it was opening never appears. Inertia's
// version check catches this on a normal navigation (409, full load); this is
// the net for whatever it misses, such as a lazy import later on the page.
//
// Reloading can't help offline, and if the chunk really is broken a reload
// would fail the same way forever, so it tries once a minute at most.
const LAST_RELOAD_KEY = "stale-chunk-reload-at"
const RETRY_AFTER_MS = 60_000

function mayReload(): boolean {
  if (!navigator.onLine) return false
  try {
    const last = Number(sessionStorage.getItem(LAST_RELOAD_KEY))
    if (Date.now() - last < RETRY_AFTER_MS) return false
    sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()))
    return true
  } catch {
    // With no way to remember the attempt, one reload could become a loop.
    return false
  }
}

export function reloadOnStaleChunk(): void {
  window.addEventListener("vite:preloadError", () => {
    if (mayReload()) window.location.reload()
  })
}
